import React, { useState, useEffect } from 'react';
import { getURL } from '../lib/supabase';
import { api } from '../lib/api';
import { supabase } from '../lib/supabase';
import './FrontPage.css';

const FrontPage: React.FC = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showSignupModal, setShowSignupModal] = useState(false);
  const [email, setEmail] = useState('');
  const [orgCode, setOrgCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowContent(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      // Use Supabase to send magic link with proper CORS handling
      const { error: supabaseError, data } = await supabase.auth.signInWithOtp({
        email: email.trim(),
        options: {
          emailRedirectTo: `${window.location.origin}/auth/callback`,
          shouldCreateUser: true,
          data: {
            redirect_url: `${window.location.origin}/auth/callback`
          }
        }
      });

      if (supabaseError) {
        console.error('Supabase error details:', supabaseError);
        throw supabaseError;
      }

      console.log('Sign in successful:', data);
      setMessage('¡Revisa tu correo para el link de ingreso!');
    } catch (error) {
      console.error('Login error details:', error);
      const errorMessage = error instanceof Error ? error.message : 'Error al enviar el correo';
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleSignup = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      // Validate org code format
      if (!orgCode.trim()) {
        setError('El código de organización es requerido');
        setLoading(false);
        return;
      }

      // 1. First validate with backend
      await api.post('/api/user/create', {
        email: email.trim(),
        org_code: orgCode.trim()
      });

      // 2. If validation successful, use Supabase to send magic link
      const { error: supabaseError } = await supabase.auth.signInWithOtp({
        email: email.trim(),
        options: {
          emailRedirectTo: `${window.location.origin}/auth/callback`,
          data: {
            org_code: orgCode.trim()
          }
        }
      });

      if (supabaseError) throw supabaseError;

      setMessage('¡Revisa tu correo para completar tu registro!');
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Error al crear la cuenta';
      setError(errorMessage);
      console.error('Signup error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="front-page">
      <div className="background-animation"></div>
      <div className={`content ${showContent ? 'show' : ''}`}>
        <main>
          <img 
            src={`${getURL()}CC Logo.svg`}
            alt="Centro de Comando Logo"
            className="logo"
          />
          <h1 className="title">Centro de Comando</h1>
          <p className="subtitle">Gestiona tu negocio de manera eficiente</p>
          <div className="cta-container">
            <button 
              className="cta-button login"
              onClick={() => {
                setShowLoginModal(true);
                setError('');
                setMessage('');
              }}
            >
              Iniciar Sesión
            </button>
            <button 
              className="cta-button signup"
              onClick={() => {
                setShowSignupModal(true);
                setError('');
                setMessage('');
              }}
            >
              Crear Cuenta
            </button>
          </div>
        </main>
      </div>

      {/* Login Modal */}
      {showLoginModal && (
        <div className="modal-overlay" onClick={(e) => {
          if (e.target === e.currentTarget) {
            setShowLoginModal(false);
            setMessage('');
            setError('');
          }
        }}>
          <div className="modal">
            <button className="close-button" onClick={() => {
              setShowLoginModal(false);
              setMessage('');
              setError('');
            }}>
              <span className="material-icons">close</span>
            </button>
            <h2>Iniciar Sesión</h2>
            <form onSubmit={handleLogin}>
              <div className="form-group">
                <label>Ingresa tu correo para recibir tu link de ingreso</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="correo@ejemplo.com"
                  required
                />
              </div>
              <button type="submit" disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar Link'}
              </button>
              {error && <p className="error-message">{error}</p>}
              {message && <p className="success-message">{message}</p>}
            </form>
          </div>
        </div>
      )}

      {/* Signup Modal */}
      {showSignupModal && (
        <div className="modal-overlay" onClick={(e) => {
          if (e.target === e.currentTarget) {
            setShowSignupModal(false);
            setMessage('');
            setError('');
          }
        }}>
          <div className="modal">
            <button className="close-button" onClick={() => {
              setShowSignupModal(false);
              setMessage('');
              setError('');
            }}>
              <i className="fas fa-times"></i>
            </button>
            <h2>Crear Cuenta</h2>
            <form onSubmit={handleSignup}>
              <div className="form-group">
                <label>Correo Electrónico</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="correo@ejemplo.com"
                  required
                />
              </div>
              <div className="form-group">
                <label>Código de Organización</label>
                <input
                  type="text"
                  value={orgCode}
                  onChange={(e) => setOrgCode(e.target.value)}
                  placeholder="Ingrese código de organización"
                  required
                />
              </div>
              <button type="submit" disabled={loading}>
                {loading ? 'Creando cuenta...' : 'Crear Cuenta'}
              </button>
              {error && <p className="error-message">{error}</p>}
              {message && <p className="success-message">{message}</p>}
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default FrontPage;